import { render, staticRenderFns } from "./expertClinicHome.vue?vue&type=template&id=68dde4b8&scoped=true&"
import script from "./expertClinicHome.vue?vue&type=script&lang=js&"
export * from "./expertClinicHome.vue?vue&type=script&lang=js&"
import style0 from "./expertClinicHome.vue?vue&type=style&index=0&id=68dde4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dde4b8",
  null
  
)

export default component.exports